import React from 'react';
import glamorous from 'glamorous';
import PropTypes from 'prop-types';
import FossaLogo from '../icons/fossa_logo.svg';
import SimpleGhostButton from '../buttons/base/ghost';
import SimpleButton from '../buttons/base/simple';
import {BLACK, FOCUS_BLUE} from '../../style/colors';
import {BASE_TEXT} from '../../style/typography';
import {PHONE, PHONE_LANDSCAPE} from '../../style/breakpoints';

const Container = glamorous.div(
  {
    ...BASE_TEXT,
    display: 'flex',
    alignItems: 'center',
    padding: 19
  },
  ({banner}) => ({
    border: banner ? 0 : '1px solid #e9e9e9',
    marginTop: banner ? 0 : 33,
    flexDirection: banner ? 'row' : 'column'
  })
);

const FossaLogoIcon = glamorous(FossaLogo)(({banner}) => ({
  width: banner ? 90 : 100,
  height: 'auto',
  marginRight: banner ? 25 : 0
}));

const Title = glamorous.div(({banner}) => ({
  fontSize: 15,
  textAlign: banner ? 'left' : 'center',
  color: BLACK,
  fontWeight: 900,
  paddingTop: banner ? 0 : 15,
  maxWidth: banner ? 425 : 'auto',
  [PHONE_LANDSCAPE]: {
    maxWidth: 280
  }
}));

const GhostButton = glamorous(SimpleGhostButton)(
  {
    textAlign: 'center',
    color: FOCUS_BLUE,
    fontWeight: 900,
    padding: 0,
    margin: '10px 0',
    letterSpacing: 0,
    height: 'auto',
    ':hover': {
      color: FOCUS_BLUE,
      textDecoration: 'underline'
    }
  },
  ({banner}) =>
    banner
      ? {
          fontSize: 15,
          width: 'fit-content',
          margin: 0,
          display: 'inline'
        }
      : {
          fontSize: 13
        }
).withComponent('a');

const Button = glamorous(SimpleButton)(({banner}) => ({
  margin: '10px 0 5px',
  width: banner ? 'auto' : '100%',
  marginLeft: banner ? 'auto' : 0,
  [PHONE]: {
    width: 100
  }
})).withComponent('a');

const SignUpPrivateStackshare = ({title = '', banner = false, extraStyle}) => {
  return (
    <Container banner={banner} style={extraStyle}>
      <FossaLogoIcon banner={banner} />
      <Title banner={banner}>
        {title}{' '}
        {banner && (
          <GhostButton banner={banner} href="https://fossa.com/fossa-developers">
            Learn more about FOSSA
          </GhostButton>
        )}
      </Title>
      {!banner && (
        <GhostButton href="https://fossa.com/fossa-developers">Learn more about FOSSA</GhostButton>
      )}
      <Button href="https://fossa.com/fossa-developers" banner={banner}>
        Learn More
      </Button>
    </Container>
  );
};

SignUpPrivateStackshare.propTypes = {
  title: PropTypes.string.isRequired,
  banner: PropTypes.bool,
  extraStyle: PropTypes.object
};

export default SignUpPrivateStackshare;
